import { render, staticRenderFns } from "./CreateSContract.vue?vue&type=template&id=6aa94d4a&scoped=true&"
import script from "./CreateSContract.vue?vue&type=script&lang=js&"
export * from "./CreateSContract.vue?vue&type=script&lang=js&"
import style0 from "./CreateSContract.vue?vue&type=style&index=0&id=6aa94d4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa94d4a",
  null
  
)

export default component.exports